import { Member } from 'application/repositories/membersRepository';
import { Profiles } from 'application/repositories/profilesRepository';
import classNames from 'classnames';
import React from 'react';
import { Container, Heading, Spinner, GridCell } from 'ui/components';
import styles from './WelcomeHeader.module.scss';

export interface WelcomeHeaderProps {
    className?: string;
	profiles: Profiles;
    welcomeTitle?: string;
    memberNumberTitle?: string;
}

export const WelcomeHeader: React.FC<WelcomeHeaderProps> = ({
    className,
    profiles,
    welcomeTitle,
    memberNumberTitle
 }) => { 

    return (
        <>
        {!profiles ? (
				<Spinner />
			) : (
				<Container className={classNames(styles.WelcomeHeader, className)} width="Full width">
					<GridCell>
							<section className={styles.WelcomeHeader__top}>
							<div className={styles.WelcomeHeader__name}>
								<Heading headingLevel="h2" className={styles.WelcomeHeader__heading}>
									<span className={styles.WelcomeHeader__greeting}>{welcomeTitle}</span>
									<span className={styles.WelcomeHeader__name}>{profiles?.firstName} {profiles?.lastName}</span>
								</Heading>
							</div>
							<div className={styles.WelcomeHeader__memberNumber}>
								<span className={styles.WelcomeHeader__memberNumberTitle}>{memberNumberTitle}</span>
								<span className={styles.WelcomeHeader__memberNumberValue}>{profiles?.membership?.id}</span>
							</div>
						</section>
					</GridCell>
                </Container>
            )}

        </>
)}